import { styled } from "@mui/material/styles";
// import TextField from "@mui/material/TextField";
// import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import TextareaAutosize from "react-textarea-autosize";
import { useState } from "react";
import { ThemeColor } from "../theme/color";
import { FontFamily } from "../theme/fontFamily";
import { fontWeight } from "../theme/fontWeight";
import { fontSize } from "../theme/fontSize";
import { FormHelperText } from "@mui/material";

const MyTextareaAutosize = styled(TextareaAutosize)(({ theme }) => ({
  width: "100%",
  padding: "10px",
  border: `0.2px solid ${ThemeColor.GREY}`,
  borderRadius: "4px",
  // opacity: 4,
  color: "black !important",

  "&:focus": {
    outline: "none",
    border: `2px solid ${ThemeColor.LIGHTPURPLE}`,
  },
  "&::placeholder": {
    color: "#ced4da",
    fontWeight: 400,
    fontSize: "0.9rem",
    letterSpacing: "0.00938em",
    fontFamily: "Lato !important",
  },
  "&:disabled": {
    cursor: "not-allowed !important",
    color: "black !important",
    backgroundColor: "white !important",
    borderColor: `${ThemeColor.GREY} !important`,
  },
}));

const OutlinedTextAreaField = ({
  label,
  value,
  multiline,
  minRows,
  onChange,
  disabled,
  name,
  type = "text",
  placeholder = "",
  fullWidth = true,
  helperText,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(type === "password");
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  return (
    <>
      <MyTextareaAutosize
        name={name}
        minRows={minRows}
        value={value}
        onChange={onChange}
        // type={type === "password" ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        disabled={disabled}
        {...rest}
      />
      {/* an always rendered helper row pushes the field out of alignment */}
      {/* component="div": callers pass a <Typography> (a <p>) as helperText, and
          FormHelperText is a <p> by default — <p> inside <p> is invalid HTML. */}
      {helperText ? (
        <FormHelperText component="div" className="mb-3">
          {helperText}
        </FormHelperText>
      ) : null}
    </>
  );
};

export default OutlinedTextAreaField;
